// components/LangSelect.jsx
import React from 'react';
import { Select } from 'antd';
import { useLanguage } from '../../providers/LanguageProvider';

const LANGS = [
  { value: 'tr', name: 'Türkçe',   code: 'TR', flag: 'https://flagcdn.com/w20/tr.png' },
  { value: 'en', name: 'English',  code: 'EN', flag: 'https://flagcdn.com/w20/gb.png' },
  { value: 'de', name: 'Deutsch',  code: 'DE', flag: 'https://flagcdn.com/w20/de.png' },
  { value: 'fr', name: 'Français', code: 'FR', flag: 'https://flagcdn.com/w20/fr.png' },
  { value: 'nl', name: 'Dutch',    code: 'NL', flag: 'https://flagcdn.com/w20/nl.png' },
];

function OptionRow({ flag, name, code }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <img
        src={flag}
        width={20}
        height={15}
        alt=""
        style={{ borderRadius: 2, boxShadow: '0 0 0 1px #dadce0' }}
      />
      <span>{name}</span>
      <span style={{ marginLeft: 'auto', color: '#5f6368' }}>{code}</span>
    </div>
  );
}

function CompactLabel({ flag, code }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <img
        src={flag}
        width={18}
        height={14}
        alt=""
        style={{ borderRadius: 2, boxShadow: '0 0 0 1px #dadce0' }}
      />
      <span>{code}</span>
    </div>
  );
}

export default function LangSelect({ value, onChange, style }) {
  const { languages, language, setLanguage, t } = useLanguage();
  const langList = (languages?.length ? languages : LANGS.map(l => ({ code: l.value, name: l.name })));
  const normalized = langList.map(l => {
    const fallback = LANGS.find(x => x.value.toLowerCase() === (l.code || '').toLowerCase()) || {};
    const codeUpper = (l.code || fallback.code || '').toUpperCase();
    const baseName = l.name || fallback.name || (l.code || '');
    // İsimleri çeviriden al: LANG_NAME_TR, LANG_NAME_EN ...
    const displayName = t ? t(`LANG_NAME_${codeUpper}`, baseName) : baseName;
    return {
      key: codeUpper,
      value: codeUpper,
      name: displayName,
      code: codeUpper,
      flag: fallback.flag,
    };
  });
  // Seçili dil en üstte, kalanlar ada göre A-Z
  const selectedCode = (language || value || '').toString().toUpperCase();
  const options = normalized.sort((a, b) => {
    if (a.value === selectedCode && b.value !== selectedCode) return -1;
    if (b.value === selectedCode && a.value !== selectedCode) return 1;
    return (a.name || a.code).localeCompare(b.name || b.code, 'tr', { sensitivity: 'base' });
  });
  const handleChange = (val) => {
    setLanguage(val);
    onChange?.(val);
  };
  return (
    <Select
      value={language || value}
      onChange={handleChange}
      size="large"
      style={{ width: 140, ...style }}
      optionLabelProp="label"
      dropdownMatchSelectWidth={240}
    >
      {options.map((l) => (
        <Select.Option
          key={l.value}
          value={l.value}
          label={<CompactLabel flag={l.flag} code={l.code} />}
        >
          <OptionRow flag={l.flag} name={l.name} code={l.code} />
        </Select.Option>
      ))}
    </Select>
  );
}
